var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 124,
    viewBox: "0 0 165 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 41.3333C38.8908 41.3333 48.125 32.0806 48.125 20.6667C48.125 9.25278 38.8908 0 27.5 0C16.1091 0 6.875 9.25278 6.875 20.6667C6.875 32.0806 16.1091 41.3333 27.5 41.3333Z",
    fill: "url(#paint0_linear_2733_580)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1187 55.5934C43.199 59.9201 37.492 65.9401 33.535 73.0868C29.578 80.2335 27.5011 88.2716 27.5 96.4445H13.75C10.1066 96.4336 6.61557 94.9785 4.0393 92.397C1.46303 89.8156 0.0108812 86.3175 0 82.6667L0 68.8889C0.0163219 63.4128 2.19455 58.1657 6.05895 54.2935C9.92335 50.4213 15.1599 48.2386 20.625 48.2223H34.375C37.3764 48.2291 40.3402 48.8922 43.0594 50.1653C45.7786 51.4384 48.1878 53.2909 50.1187 55.5934Z",
    fill: "url(#paint1_linear_2733_580)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.5 41.3333C148.891 41.3333 158.125 32.0806 158.125 20.6667C158.125 9.25278 148.891 0 137.5 0C126.109 0 116.875 9.25278 116.875 20.6667C116.875 32.0806 126.109 41.3333 137.5 41.3333Z",
    fill: "url(#paint2_linear_2733_580)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 68.8889V82.6667C164.989 86.3175 163.537 89.8156 160.96 92.397C158.384 94.9785 154.893 96.4336 151.25 96.4445H137.5C137.498 88.2716 135.422 80.2335 131.465 73.0868C127.508 65.9401 121.801 59.9201 114.881 55.5934C116.812 53.2909 119.221 51.4384 121.94 50.1653C124.659 48.8922 127.623 48.2291 130.625 48.2223H144.375C149.84 48.2386 155.076 50.4213 158.941 54.2935C162.805 58.1657 164.983 63.4128 165 68.8889Z",
    fill: "url(#paint3_linear_2733_580)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 55.1111C97.6878 55.1111 110 42.7741 110 27.5556C110 12.337 97.6878 0 82.5 0C67.3122 0 55 12.337 55 27.5556C55 42.7741 67.3122 55.1111 82.5 55.1111Z",
    fill: "url(#paint4_linear_2733_580)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M123.75 96.4444V103.333C123.734 108.809 121.555 114.057 117.691 117.929C113.827 121.801 108.59 123.984 103.125 124H61.875C56.4099 123.984 51.1734 121.801 47.3089 117.929C43.4445 114.057 41.2663 108.809 41.25 103.333V96.4444C41.25 87.3092 44.8716 78.5481 51.3182 72.0885C57.7648 65.629 66.5082 62 75.625 62H89.375C98.4918 62 107.235 65.629 113.682 72.0885C120.128 78.5481 123.75 87.3092 123.75 96.4444Z",
    fill: "url(#paint5_linear_2733_580)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2733_580",
    x1: 27.5,
    y1: 0,
    x2: 27.5,
    y2: 41.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2733_580",
    x1: 25.0594,
    y1: 48.2223,
    x2: 25.0594,
    y2: 96.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2733_580",
    x1: 137.5,
    y1: 0,
    x2: 137.5,
    y2: 41.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2733_580",
    x1: 139.94,
    y1: 48.2223,
    x2: 139.94,
    y2: 96.4445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2733_580",
    x1: 82.5,
    y1: 0,
    x2: 82.5,
    y2: 55.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2733_580",
    x1: 82.5,
    y1: 62,
    x2: 82.5,
    y2: 124,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5663EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4151B3"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonIcon);
export default __webpack_public_path__ + "static/media/personIcon.917fad4ab2a20ad08bf11d640c58072e.svg";
export { ForwardRef as ReactComponent };